// Shared design tokens for the landing page.
// Keep every color/spacing decision here so a change lands in one place.

export const c = {
  bg: "#FFFFFF",
  bgSoft: "rgba(250,250,253,0.78)",
  bgTint: "#EEF2FF",
  ink: "#111827",
  inkSoft: "#6B7280",
  inkMuted: "#9CA3AF",
  purple: "#818CF8",
  purpleDeep: "#4F46E5",
  purpleInk: "#4338CA",
  purpleBrand: "#6258E8", // the hero orb's core hue — anchor for every purple accent
  purpleSoft: "#A5B4FC",  // pastel lavender, matches the orb's outer glow
  purpleMist: "#C7D2FE",  // lightest pastel tint for soft fills
  teal: "#DBEAFE",
  white: "#FFFFFF",
  line: "rgba(20,21,26,0.08)",
  lineStrong: "rgba(20,21,26,0.12)",
};

export const mono = "'JetBrains Mono', 'IBM Plex Mono', ui-monospace, monospace";

export const section = {
  px: { xs: 2.5, md: 4.5 },
  pb: { xs: 7.5, md: 12 },
};

export const maxW = "1140px";

// Small caps mono label used above every section heading.
export const eyebrowSx = {
  fontFamily: mono,
  fontSize: "11.5px",
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: c.purpleDeep,
  mb: 2.25,
};

// Big display heading.
export const h2Sx = {
  fontSize: "clamp(32px, 5vw, 62px)",
  lineHeight: 1.04,
  letterSpacing: "-0.035em",
  fontWeight: 650,
  color: c.ink,
  textWrap: "balance",
};

// Soft, brand-tinted card shadow shared across the hero and every section — the smooth,
// borderless look the hero established (no hairline, no hover motion).
export const softShadow = "0 34px 80px -34px rgba(66,46,170,0.34), 0 2px 8px rgba(20,21,26,0.05)";

export const cardSx = {
  bgcolor: c.white,
  borderRadius: "22px",
  p: { xs: 3.5, md: 4.25 },
  boxShadow: softShadow,
  transition: "none",
  "&:hover": {boxShadow: softShadow},
};

export const pillButtonSx = {
  borderRadius: "980px",
  textTransform: "none",
  fontSize: "15px",
  fontWeight: 500,
  px: 3.5,
  py: 1.75,
};

// Pastel-purple gradient that echoes the hero orb (soft lavender -> brand core).
// Use for every primary call to action so the buttons read as the same material as the orb.
export const purpleGradient = "linear-gradient(135deg, #818CF8 0%, #6258E8 100%)";
export const purpleGradientHover = "linear-gradient(135deg, #6258E8 0%, #4F46E5 100%)";

// Shared primary-button look. Spread it into a Button's sx, then override px/py/fontSize per use.
export const primaryButtonSx = {
  borderRadius: "980px",
  textTransform: "none",
  fontWeight: 600,
  color: "#FFFFFF",
  background: purpleGradient,
  boxShadow: "0 14px 30px -16px rgba(98,88,232,0.65)",
  transition: "transform 300ms cubic-bezier(.16,1,.3,1), box-shadow 300ms cubic-bezier(.16,1,.3,1), background 300ms cubic-bezier(.16,1,.3,1)",
  "&:hover": {
    background: purpleGradientHover,
    boxShadow: "0 20px 40px -16px rgba(98,88,232,0.75)",
    transform: "translateY(-2px)",
  },
  "&.Mui-disabled": {
    color: "rgba(255,255,255,0.7)",
    background: "rgba(129,140,248,0.4)",
    boxShadow: "none",
  },
};
